import React from 'react';
import { createRoot } from 'react-dom/client';
import 'normalize.css';

import App from './App';

const container = document.getElementById('root');

if (!container) {
    throw new Error('The <div id="root"> element was not found.">');
}

const root = createRoot(container);

root.render(
    <React.StrictMode>
        <App />
    </React.StrictMode>
);
